<template>
  <div class="progress-wrap">
    <span class="apply-node">
      <span class="el-icon-s-custom node-icon" :style="firstColor"></span>
      <span class="state">已提交</span>
      <span class="time">{{ info.auditStatus == 0 ? latest.operationTime : first.operationTime }}</span>
    </span>
    <div class="progress">
      <el-progress :percentage="percentage" :color="progressColor" :show-text="false"></el-progress>
      <div class="duiring" v-if="info.auditStatus === 0">{{ getDuringTime() }}</div>
    </div>
    <span class="apply-node">
      <span class="el-icon-s-custom node-icon" :style="secondColor"></span>
      <span class="state">{{ secondLabel }}</span>
      <span class="time">{{ info.auditStatus == 0 ? "" : latest.operationTime }}</span>
    </span>
  </div>
</template>
<script>
import DayJs from "dayjs"
const colorEnum = {
  red: "#FF1818",
  blue: "#1890FF",
  gray: "#c5c5c5"
}
export default {
  props: ["info"],
  data() {
    return {}
  },
  computed: {
    first() {
      return this.info.approveList[1] || {}
    },
    latest() {
      return this.info.approveList[0]
    },
    progressColor() {
      let color = "";
      switch (this.info.auditStatus) {
        case 2:
          color = colorEnum.red;
          break;
        case 3:
          color = colorEnum.gray;
          break;
        default:
          color = colorEnum.blue;
          break;
      }
      return color;
    },
    percentage() {
      let progress = 0
      switch (this.info.auditStatus) {
        case 1:
        case 3:
          progress = 100
          break;
        default:
          progress = 50
          break;
      }
      return progress
    },
    firstColor() {
      let color = "";
      switch (this.info.auditStatus) {
        case 2:
          color = colorEnum.red;
          break;
        case 3:
          color = colorEnum.gray;
          break;
        default:
          color = colorEnum.blue;
          break;
      }
      return { backgroundColor: color };
    },
    secondColor() {
      return { backgroundColor: this.info.auditStatus == 1 ? colorEnum.blue : colorEnum.gray }
    },
    secondLabel() {
      let label = "";
      switch (this.info.auditStatus) {
        case 0:
          label = "待处理"
          break;
        case 1:
          label = "已通过"
          break;
        case 2:
          label = "已驳回"
          break;
        case 3:
          label = "已撤回"
          break;
      }
      return label;
    }
  },
  methods: {
    getDuringTime() {
      let timeStr = "";
      const nowTime = DayJs(new Date()).format("YYYY-MM-DD HH:mm:ss");
      const lastTime = this.latest.operationTime;
      const dayDiff = DayJs(nowTime).diff(lastTime, "day")
      const hourDiff = DayJs(nowTime).diff(lastTime, "hour") - dayDiff * 24;
      const minuteDiff = DayJs(nowTime).diff(lastTime, "minute") - dayDiff * 24 - hourDiff * 60;
      if (dayDiff > 0) timeStr += `${dayDiff}天`;
      if (hourDiff > 0) timeStr += `${hourDiff}小时`;
      if (minuteDiff > 0) timeStr += `${minuteDiff}分钟`;
      if (dayDiff === 0 && hourDiff === 0 && minuteDiff === 0) {
        return "";
      }
      return `已经等待${timeStr}`
    },
  }
}
</script>
<style lang="scss" scoped>
.apply-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  .node-icon {
    width: 50px;
    height: 50px;
    font-size: 32px;
    border-radius: 30px;
    color: #fff;
    position: relative;
    &::before {
      position: absolute;
      top: 46%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .state {
    font-size: 16px;
    line-height: 2.5;
  }
  .time {
    color: #8c8c8c;
    font-size: 14px;
  }
}
.progress-wrap {
  display: flex;
  padding: 30px 10%;
  .progress {
    flex: 1;
    margin: 18px 40px 0;
    text-align: center;
  }
  .duiring {
    margin-top: 10px;
  }
}
</style>